<template>
  <!-- <div id="workbench"></div> -->
  <div id="review-report">
    <div class="ipub-h1 mar-b-20">
      <span v-if="type ==='PRE_CHECK'">Pre-Check Request</span>
      <span v-if="type ==='FIRST_CHECK'">First Decision Request</span>
      <span v-if="type ==='FINAL_CHECK'">Final Decision Request</span>
    </div>
    <div class="content-bg"
         style="padding-bottom:40px">
      <div>
        <div class="ipub-h3 line-h-40 ipub-title-tab mar-b-10">
          Manuscript Information
        </div>
        <div class="mar-b-10 ipub-p2 ipub-title-tab-part">
          <div class="mar-b-12 flex">
            <span class="fw-bd ipub-block__span">Manuscript No.</span>&nbsp;
            <span class="ipub-block__font">{{journalResponse.code}}</span>
          </div>
          <div class="ipub-p2 mar-b-12 flex">
            <span class="fw-bd ipub-block__span">Article Type</span>&nbsp;
            <span class="ipub-block__font">{{journalResponse.detail && manuscriptType[journalResponse.detail.typeCode]}}</span>
          </div>
          <div class="ipub-p2 flex mar-b-12">
            <span class="fw-bd ipub-block__span">Article Title</span>&nbsp;
            <span class="ipub-block__font">{{journalResponse.detail && journalResponse.detail.title}}</span>
          </div>
          <div class="ipub-p2 flex mar-b-12">
            <span class="fw-bd ipub-block__span"
                  style="line-height:30px">Attachment(s)</span>&nbsp;
            <div class="ipub-block__font"
                 v-if="journalResponse.fileList && journalResponse.fileList.length">
              <ipub-label class="ipub-c-p ipub-p2"
                          style="margin:0 6px 10px"
                          type="link"
                          v-for="(item,index) in journalResponse.fileList"
                          :key="item.id"
                          @click="download(item,index)">
                {{item.name}}
                <ipub-icon type="iconDownload1"
                           class="mar-l-10" />
              </ipub-label>
            </div>
          </div>
        </div>
      </div>
      <!-- Pre-Check History  academicHistoryList -->
      <div class="mar-b-10"
           v-if="reviews.academicHistoryList && reviews.academicHistoryList.length>0">
        <div class="ipub-h3 line-h-40 mar-b-4 ipub-cursor-pointer ipub-title-tab"
             @click="()=>{showVersion1 = !showVersion1}">
          <span v-if="type ==='PRE_CHECK'">Pre-check History</span>
          <span v-else>Decision History</span>
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showVersion1?'rotate-180':'']"
                     type="iconArrow" />
        </div>
        <div v-show="showVersion1 && reviews.academicHistoryList && reviews.academicHistoryList.length>0"
             class="mar-b-12"
             v-for="(item,index) in reviews.academicHistoryList"
             :key="'editorHistory'+index">
          <div class="ipub-p1 line-h-40 mar-b-12 ipub-cursor-pointer ipub-title-report"
               v-if="type !='PRE_CHECK'"
               @click="togalReport(item,'showReport')">
            <ipub-label cover
                        size="small"
                        type="warning">V{{item.sign}}</ipub-label>
            <span v-if="item.decisionType ==='FIRST_CHECK'"
                  class="mar-l-10">First Decision</span>
            <span v-if="item.decisionType ==='FINAL_CHECK'"
                  class="mar-l-10">Final Decision</span>
            <ipub-icon :class="['ipub-p2 mar-l-10 rotate',item.showReport?'':'rotate-180']"
                       type="iconArrow" />
          </div>
          <div :class="['ipub-title-tab-part',(type ==='PRE_CHECK' &&reviews.academicHistoryList &&reviews.academicHistoryList.length>1)? 'border-bottom':''] "
               v-if="!item.showReport">
            <div class="ipub-p2">
              <div class="mar-b-8 flex">
                <span class="fw-bd ipub-block__span">Academic Editor</span>&nbsp;
                <span class="ipub-block__font">{{title[item.person.titleCode]}} {{item.person.firstName}} {{item.person.lastName}}
                  (<a class="link-color"
                     :href="`mailto:${item.person.email}`">{{item.person.email}}</a>)
                </span>
              </div>
              <div class="mar-b-8 flex">
                <span class="fw-bd ipub-block__span">Invited Date</span>&nbsp;
                <span class="ipub-block__font">{{item.invitedTime ? $moment(item.invitedTime).format('DD / MM / YYYY') : '--'}}</span>
              </div>
              <div class="mar-b-8 flex">
                <span class="fw-bd ipub-block__span">Decision Date</span>&nbsp;
                <span class="ipub-block__font">{{item.completedTime ? $moment(item.completedTime).format('DD / MM / YYYY') : '--'}}</span>
              </div>
              <div class="mar-b-8 flex">
                <span class="fw-bd ipub-block__span">Decision</span>&nbsp;
                <span class="ipub-block__font ipub-c-p"
                      @click="showDecision(item)">{{termListStatus[item.decisionStatus]}}</span>
              </div>
              <div class="mar-b-20">
                <div class="ipub-p2 fw-bd fw-bd mar-b-12 ipub-cursor-pointer"
                     @click="togalReport(item,'showEditor')">
                  Comments to Editor
                  <ipub-icon :class="['ipub-p5 mar-l-10 rotate',item.showEditor?'':'rotate-180']"
                             type="iconArrow" />
                </div>
                <div class="ipub-p2"
                     v-if="!item.showEditor">
                  <div class="ipub-p2"
                       v-if="item.editorNotes"
                       v-html="item.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                  <div v-else
                       class="line-color">{{ 'No notes or comments.'}}</div>
                </div>
              </div>
              <div class="mar-b-20 ipub-p2">
                <div class="ipub-p2 fw-bd fw-bd mar-b-12 ipub-cursor-pointer"
                     @click="togalReport(item,'showAuthor')">
                  Comments to Author
                  <ipub-icon :class="['ipub-p5 mar-l-10 rotate',item.showAuthor?'':'rotate-180']"
                             type="iconArrow" />
                </div>
                <div class="ipub-p2"
                     v-if="!item.showAuthor">
                  <div class="ipub-p2"
                       v-if="item.authorNotes"
                       v-html="item.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                  <div v-else
                       class="line-color">{{ 'No notes or comments.'}}</div>
                </div>
              </div>
              <div class="mar-b-20"
                   v-if="item.authorReply">
                <div :class="['ipub-p2', 'fw-bd', 'mar-b-12', 'ipub-cursor-pointer', type ==='PRE_CHECK'?'':'border-top']"
                     @click="togalReport(item,'showAuthorReplay')">
                  Author’s Response to Report
                  <ipub-icon :class="['ipub-p5 mar-l-10 rotate',item.showAuthorReplay?'':'rotate-180']"
                             type="iconArrow" />
                </div>
                <div class="ipub-p2"
                     v-if="!item.showAuthorReplay"
                     v-html="item.authorReply.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Reviewer -->
      <div v-if="reviewsResponse && type !='PRE_CHECK'"
           class="mar-b-20">
        <div class="ipub-h3 line-h-40 ipub-cursor-pointer ipub-title-tab mar-b-16"
             @click="()=>{showDecision1 = !showDecision1}">
          Reviewers’ Report(s)
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',showDecision1?'':'rotate-180']"
                     type="iconArrow" />
        </div>
        <div class="ipub-title-tab-part mar-b-20"
             v-if="!showDecision1">
          <template v-if="reviewsResponse && reviewsResponse.signList && reviewsResponse.signList.length>0">
            <div class="ipub-p2 fw-bd flex mar-b-8">
              <span style="width:120px;padding-left:12px">Reviewer</span>
              <div :key="'sign'+index"
                   style="width:220px"
                   v-for="(item,index) in reviewsResponse.signList">
                Round {{item}}
              </div>
            </div>
          </template>
          <template v-if="reviewsResponse && reviewsResponse.reviewerList && reviewsResponse.reviewerList.length>0">
            <div :key="item.id"
                 class="flex mar-b-4 part-border"
                 style="padding-bottom:8px"
                 v-for="(item,index) in reviewsResponse.reviewerList">
              <span style="width:120px"
                    class="ipub-p2">Reviewer {{index+1}}</span>
              <div v-for="(sign,signindex) in reviewsResponse.signList"
                   style="width:220px"
                   :key="'sign1'+signindex">
                <p :class="['ipub-p2', 'ipub-cursor-pointer',(activeKey[0]===item.id && activeKey[1]==sign)?'link-color':'']"
                   v-if="reviewsResponse.reviewerDecisionList && reviewsResponse.reviewerDecisionList.filter(ele=>ele.personId===item.id && sign==ele.sign) && reviewsResponse.reviewerDecisionList.filter(ele=>ele.personId===item.id && sign==ele.sign).length>0"
                   @click="showReportDetail(item.id,sign,index)">
                  <ipub-icon type='iconViewDetails' />
                  {{termListStatus[(reviewsResponse.reviewerDecisionList.filter(ele=>ele.personId===item.id && sign==ele.sign)[0]).decisionStatus]}}
                </p>
                <p v-else>- -</p>
              </div>
            </div>
          </template>
        </div>
        <div v-if="activeData">
          <div class="flex title-tab mar-b-20 ipub-title-report"
               v-if="activeData.decisionStatus">
            <div :class="['ipub-p2','title-tab-item','line-h-40']">Reviewer{{activeData.__index+1}} Decision: <span class="ipub-p2 fw-bd">{{termListStatus[activeData.decisionStatus]}}</span></div>
          </div>
          <div style="padding:0 16px">
            <div class="mar-b-20">
              <div class="ipub-p2 fw-bd fw-bd mar-b-12 ipub-cursor-pointer"
                   @click="togalReport(activeData,'showAuthor')">
                Comments to Author
                <ipub-icon :class="['ipub-p5 mar-l-10 rotate',activeData.showAuthor?'':'rotate-180']"
                           type="iconArrow" />
              </div>
              <div v-if="!activeData.showAuthor">
                <div class="ipub-p2"
                     v-if="activeData.authorNotes"
                     v-html="activeData.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>

                <template v-else>
                  <div class="line-color">No notes or comments.</div>
                </template>
              </div>

            </div>
            <div class="mar-b-20">
              <div class="ipub-p2 fw-bd fw-bd mar-b-12 ipub-cursor-pointer"
                   @click="togalReport(activeData,'showEditor')">
                Comments to Editor
                <ipub-icon :class="['ipub-p5 mar-l-10 rotate',activeData.showEditor?'':'rotate-180']"
                           type="iconArrow" />
              </div>
              <div v-if="!activeData.showEditor">
                <div class="ipub-p2"
                     v-if="activeData.editorNotes"
                     v-html="activeData.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                <template v-else>
                  <div class="line-color">No notes or comments.</div>
                </template>

              </div>

            </div>
            <div class="mar-b-20"
                 v-if="activeData.reviewerFileList && activeData.reviewerFileList.length>0 && activeData.reviewFileVisible===true">
              <div class="ipub-p2 fw-bd fw-bd mar-b-12 ipub-cursor-pointer"
                   @click="togalReport(activeData,'showFile')">
                Attachment(s)
                <ipub-icon :class="['ipub-p5 mar-l-10 rotate',activeData.showFile?'':'rotate-180']"
                           type="iconArrow" />
              </div>
              <div v-if="!activeData.showFile">
                <ipub-label class="mar-b-10 ipub-p2"
                            style="margin-right:6px"
                            :key="item.id"
                            v-for="(item,index) in activeData.reviewerFileList">
                  <div style="cursor:pointer;"
                       class="ipub-p2"
                       @click="download(item,index)">{{item.name}}
                    <ipub-icon type="iconDownload1"
                               class="mar-l-10"></ipub-icon>
                  </div>
                </ipub-label>
              </div>
            </div>
            <div class="mar-b-20 ">
              <a :name="'toReport'">
                <div class="ipub-p2 fw-bd mar-b-12 ipub-cursor-pointer border-top"
                     @click="togalReport(activeData,'showAuthorReplay')"
                     v-if="activeData.authorReply || (activeData.authorReplyFileList && activeData.authorReplyFileList.length>0)">
                  Author’s Response
                  <ipub-icon :class="['ipub-p5 mar-l-10 rotate',activeData.showAuthorReplay?'':'rotate-180']"
                             type="iconArrow" />
                </div>
                <div v-if="!activeData.showAuthorReplay">
                  <div v-show="activeData.authorReply">
                    <div class="ipub-p2 fw-bd fw-bd mar-b-12">
                      Author’s Note
                    </div>
                    <div class="ipub-p2"
                         v-html="activeData.authorReply?activeData.authorReply.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' '):'- -'"></div>
                  </div>
                  <div v-show="activeData.authorReplyFileList  && activeData.authorReplyFileList.length>0 && activeData.authorFileVisible===true">
                    <div class="ipub-p2 fw-bd fw-bd mar-b-12">
                      Author’s Response File
                    </div>
                    <ipub-label class="mar-b-10 ipub-p2"
                                style="margin-right:6px"
                                :key="item.id"
                                v-for="(item,index) in activeData.authorReplyFileList">
                      <div style="cursor:pointer;"
                           class="ipub-p2"
                           @click="download(item,index)">{{item.name}}
                        <ipub-icon type="iconDownload1"
                                   class="mar-l-10"></ipub-icon>
                      </div>
                    </ipub-label>
                  </div>
                </div>
              </a>
            </div>

            <div class="mar-b-20 border-top"
                 v-if="activeData.questionList && activeData.questionList.length>0">
              <div class="ipub-p2 fw-bd mar-b-12 ipub-cursor-pointer"
                   @click="togalReport(activeData,'showQuestion')">
                Custom Review Questions
                <ipub-icon :class="['ipub-p5 mar-l-40 rotate',activeData.showQuestion?'rotate-180':'']"
                           type="iconArrow" />
              </div>
              <div class="question-answer"
                   v-if="activeData.showQuestion">
                <customerReviewQuestion :questionList="activeData.questionList"></customerReviewQuestion>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <div class="ipub-h3 line-h-40  mar-b-20 ipub-cursor-pointer ipub-title-tab"
             @click="e => {showExternal = !showExternal}">
          Academic Editor’s Decision
          <ipub-icon :class="['ipub-p5 mar-l-10 rotate',showExternal?'':'rotate-180']"
                     type="iconArrow" />
        </div>
        <div v-if="!showExternal"
             class="mar-b-20 ipub-title-tab-part">
          <ipub-form ref="reviews-commit"
                     :model="reviews"
                     :rules="rules">
            <div class="flex mar-b-10">
              <span class="ipub-p2 fw-bd ">Decision</span>
              <font class="key-color">*</font>
              <ipub-radio-group v-model="reviews.decisionStatus"
                                @change="changeStatus"
                                class="mar-l-16"
                                v-if="!isView">
                <ipub-radio v-for="(value, key) in termList"
                            :key="key"
                            :value="key">
                  <div style="margin-right:22px;font-size:14px"
                       class="ipub-p2">{{ value }}</div>
                </ipub-radio>
              </ipub-radio-group>
              <span class="ipub-p2 fw-bd mar-l-16"
                    v-if="isView">{{termList[reviews.decisionStatus]}}
              </span>
            </div>
            <div class="mar-b-12">
              <ipub-form-item prop="editorNotes"
                              label=""
                              style="margin-bottom:12px">
                <div slot="label"
                     class="ipub-p2 fw-bd mar-b-4">Comments to Editor
                  <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',showEditor?'':'rotate-180']"
                             v-if="isView"
                             @click="showEditor=!showEditor"
                             type="iconArrow" />
                </div>
                <ipub-textarea placeholder="Comments to Editor"
                               v-model.trim="reviews.editorNotes"
                               v-if="!isView"
                               :autoSize="{ cols: '', rows: '6' }" />
                <div v-if="isView && !showEditor">
                  <div v-html="reviews.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"
                       v-if="reviews.editorNotes"></div>
                  <div v-else
                       class="line-color">{{ 'No notes or comments.'}}</div>
                </div>
              </ipub-form-item>
            </div>
            <div class="mar-b-12">
              <ipub-form-item prop="authorNotes"
                              label=""
                              style="margin-bottom:12px">
                <div slot="label"
                     class="ipub-p2 fw-bd mar-b-4">Comments to Author
                  <font v-if="(!['ACCEPT_CURRENT','PEER_REVIEW'].includes(reviews.decisionStatus) && type==='PRE_CHECK')"
                        class="key-color">*</font>
                  <ipub-icon :class="['ipub-p5 mar-l-40 rotate ipub-cursor-pointer',showAuthor?'':'rotate-180']"
                             v-if="isView"
                             @click="showAuthor=!showAuthor"
                             type="iconArrow" />
                </div>
                <ipub-textarea placeholder="Comments to Author"
                               v-model.trim="reviews.authorNotes"
                               v-if="!isView"
                               :autoSize="{ cols: '', rows: '6' }" />
                <div v-if="isView && !showAuthor">
                  <div v-html="reviews.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"
                       v-if="reviews.authorNotes"></div>
                  <div v-else
                       class="line-color">{{ 'No notes or comments.'}}</div>
                </div>

              </ipub-form-item>
            </div>

            <div class="ipub-p2 fw-bd flex fw-bd line-h-20 relative mar-b-10"
                 v-if="!isView || (isView && reviewerFileList && reviewerFileList.length>0)">
              <span>Attachment(s)</span>
              <div class="mar-l-20"
                   v-if="!isView">
                <ipub-upload v-if="!loading"
                             @change="handleUpload"
                             class="ipub-c-p link-color"
                             multiple>
                  <ipub-icon type="iconAdd" /> Add New Review Document
                </ipub-upload>
                <font class="line-color"
                      v-else>
                  <ipub-icon :type="loading?'loading':'iconAdd'" /> Add New Review Document
                </font>
              </div>
            </div>
            <div class="file-contain">
              <ul class="flex file-list mar-b-40">
                <ipub-label class="mar-b-10 ipub-p2"
                            style="margin-right:6px"
                            :key="'reviewerFileList'+index"
                            v-for="(item,index) in reviewerFileList">
                  <div style="cursor:pointer;"
                       class="border-right  ipub-p2"
                       @click="download(item,index)">{{item.name}}
                    <ipub-icon type="iconDownload1"
                               class="mar-l-10"></ipub-icon>
                  </div>
                  <ipub-icon class="mar-l-10 ipub-cursor-pointer ipub-p2"
                             v-if="!isView"
                             @click="del(index)"
                             type="iconDelete" />
                </ipub-label>
              </ul>
            </div>
            <div v-if="type==='PRE_CHECK'">
              <div class="ipub-p2 fw-bd fw-bd line-h-40 relative mar-b-20">
                <span v-if="(isView && reviews.reviewerList && reviews.reviewerList.length>0 && (reviews.reviewerList[0].firstName || reviews.reviewerList[0].lastName || reviews.reviewerList[0].email)) || !isView">Suggested Reviewers</span>
                <font class="link-color mar-l-20 ipub-cursor-pointer"
                      @click="addReviewer"
                      v-if="!isView">
                  <ipub-icon type="iconAdd" />Add
                </font>
                <span v-show="isView && (item.firstName || item.lastName || item.email)"
                      style="margin-left:20px;color:#536576;background:#fff;padding:8px 12px"
                      v-for="(item,index) in reviews.reviewerList"
                      :key="'item'+index">{{item.firstName }} {{item.lastName}}{{item.email ? '('+item.email+')': ''}}</span>
              </div>
              <div v-show="!isView"
                   v-for="(item,index) in reviews.reviewerList"
                   :key="'item'+index"
                   class="flex">
                <div style="width:30%">
                  <ipub-form-item prop="firstName"
                                  label="First Name">
                    <ipub-input v-model.trim="item.firstName"
                                placeholder="First Name" />
                  </ipub-form-item>
                </div>
                <div class="mar-l-16"
                     style="width:30%">
                  <ipub-form-item prop="lastName"
                                  label="Last Name">
                    <ipub-input v-model.trim="item.lastName"
                                placeholder="Last Name" />
                  </ipub-form-item>
                </div>
                <div class="mar-l-16"
                     style="width:30%">
                  <ipub-form-item prop="email"
                                  label="Email">
                    <ipub-input v-model.trim="item.email"
                                placeholder="Email" />
                  </ipub-form-item>
                </div>
                <div class="mar-l-16 ipub-cursor-pointer"
                     style="width:3%">
                  <div class="flex"
                       style="align-items: center;justify-content: center;width: 100%;height: 100%;">
                    <!-- <ipub-button type="primary"
                             plain
                             @click="delReviewer(index)">delete</ipub-button> -->
                    <div @click="delReviewer(index)"
                         class="del-style ipub-cursor">
                      <ipub-icon type="iconDelete"
                                 style="font-size:20px"
                                 class="ipub-p2"></ipub-icon>

                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="reviews.guestEditorList && reviews.guestEditorList.length>0 && reviews.geed=='1'">
              <div class="flex mar-b-20">
                <!-- <div class="mar-b-10"
               style="min-width:160px">

          </div> -->
                <span class="ipub-p2 fw-bd ">Signature</span>
                <font class="key-color">*</font>

                <ipub-radio-group v-model="reviews.guestEditorPersonId"
                                  class="mar-l-16"
                                  v-if="!isView">
                  <ipub-radio v-for="(value, key) in reviews.guestEditorList"
                              :key="value.id"
                              style="display:inline-block"
                              :value="value.id">
                    <div style="margin-right:22px;font-size:14px"
                         class="ipub-p2">{{value.firstName}}{{ value.lastName }}</div>
                  </ipub-radio>
                </ipub-radio-group>
                <span class="ipub-p2 fw-bd mar-l-16"
                      v-if="isView">{{reviews.person && reviews.person.firstName}}{{reviews.person && reviews.person.lastName}}
                </span>
              </div>
            </div>

            <div v-if="isView">
              <div class="ipub-h5 mar-b-20"
                   v-if="reviews.authorReply || (reviews.authorFileList && reviews.authorFileList.length>0)">Author Response to Report</div>
              <div class="mar-b-12"
                   v-if="reviews.authorReply">
                <ipub-form-item prop="authorNotes"
                                label=""
                                style="margin-bottom:12px">
                  <div slot="label"
                       class="ipub-p2 fw-bd mar-b-10">Authors' Notes
                    <font class="key-color">*</font>
                  </div>
                  <ipub-textarea placeholder="Authors' Notes"
                                 v-model.trim="reviews.authorReply"
                                 :disabled="isView"
                                 :autoSize="{ cols: '', rows: '6' }" />
                </ipub-form-item>
              </div>
              <div class="ipub-p2 fw-bd fw-bd relative mar-b-20"
                   v-if="reviews.authorFileList && reviews.authorFileList.length>0">
                <span class="ipub-p2 mar-b-10">Author's Notes File</span>
                <div class="flex">
                  <ipub-label class="ipub-cursor-pointer mar-b-10 ipub-p2"
                              style="margin-right:8px"
                              hover
                              :key="'reviewerFileList'+index"
                              v-for="(item,index) in reviews.authorFileList"
                              @click="download(item,index)">{{item.name}}<ipub-icon type="iconDownload1"
                               class="mar-l-10"></ipub-icon>
                  </ipub-label>
                </div>

              </div>
            </div>
          </ipub-form>

          <div class="mar-b-20"
               v-if="!isView">
            <ipub-button type="primary"
                         plain
                         :style="{ minWidth: '150px' }"
                         v-if="type!=='PRE_CHECK'"
                         @click="$router.back(-1)">Cancel</ipub-button>
            <ipub-button type="primary"
                         :style="{ minWidth: '150px' }"
                         @click="commit()">Confirm</ipub-button>
          </div>
          <!-- <div v-else
             class="mar-b-40">
          <ipub-button type="primary"
                       plain
                       :style="{ minWidth: '150px' }"
                       @click="$router.back(-1)">Back</ipub-button>
        </div> -->
        </div>
      </div>
    </div>

  </div>
  <!-- <report-detail :isVisable="showReport"
                   :info="activeData"
                   @cancel="cancel"></report-detail> -->
</template>



<script>
import main from './main.js'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';
</style>
